<template>
  <select
    :class="className"
    :style="cssStyle"
    :value="modelValue"
    @input="updateValue($event.target as HTMLSelectElement)"
    @blur="handleBlur"
  >
    <option v-if="isEmpty" :value="emptyCode">{{ emptyName }}</option>
    <option
      v-for="item in comboData"
      :key="item[keyField]"
      :value="item[keyField]"
    >
      {{ item[valueField] }}
    </option>
  </select>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
let isChanged=ref(false);

//親から子」にdataを伝達する手段「props」親から設定する。
//Composition APIでは、子コンポーネントでpropsを宣言し、
//親コンポーネントからデータを受け取るためにdefineProps() 関数を使用します。
const props = defineProps({
  isEmpty: Boolean,
  emptyCode: {
    type: String,
    default: "0",
  },
  emptyName: {
    type: String,
    default: "",
  },
  modelValue: {
    type: [String, Number],
  },
  comboData: {
    type: Object,
    default: () => ({}),
  },
  //コンボボックスの値一覧
  keyField: {
    type: String,
    required: true,
  },
  //コンボボックスの表示一覧
  valueField: {
    type: String,
    required: true,
  },
  className: {
    type: String,
    default: "",
  },
  cssStyle: {
    type: String,
    default: "",
  },
});

// blurイベントのハンドラ
function handleBlur(event: FocusEvent) {
  if (isChanged.value==true) 
  {
    emit("blur", event); // 親にblurイベントを伝達
    isChanged.value=false;
  }
 
}
// const selectedCode = ref('');

// watch(selectedCode, (newValue, oldValue) => {
//   if (newValue !== oldValue) {
//     emit('selectedCodeChanged', { value: newValue });
//   }
// });

//「子から親」にdataを伝達する手段「emit」が存在します。
//emitは子コンポーネントから親コンポーネントにイベントを発信するために使用され、
//データの流れは子から親への一方通行です。子コンポーネントは親コンポーネントにデータやイベントを送信できます。

const emit = defineEmits(["update:modelValue", "modelValueChanged", "blur"]); // v-model更新用のイベント

// 値が変わったときにemitする関数(このコンポーネントのinputイベント)
function updateValue(target: HTMLSelectElement) {
  
  const value = target.value;
  
  // modelValueの型に応じて適切に値を返す（数値の可能性をチェック）
  //value という変数を受け取り、その値が数値として解釈可能かどうかを判断しています。
  //具体的には、Number(value) が NaN（Not a Number、数値ではない）を返すかどうかをチェックしています。
  //JavaScriptで Number() 関数は文字列や他の値を数値に変換しようと試みますが、変換できない場合は NaN を返します

  //isNaN() が false を返す場合（value が有効な数値に変換できる場合）
  //Number(value) による数値変換結果が newValue に代入されます。
  //const newValue = isNaN(Number(value)) ? value : Number(value);
  const newValue = isNaN(Number(value)) ? value : Number(value);


  //第一引数はトリガーしたいイベントの名前を指定します。この名前は文字列として渡され、
  //子コンポーネントから親コンポーネントに送信されるイベントを識別します。

  //第二引数はイベントに関連付けたいデータを含めます。
  //これは子コンポーネントから親コンポーネントに渡すデータです。この引数は省略可能で、
  //必要に応じて使用します。データは任意の型 (文字列、オブジェクト、数値など) で渡すことができます

  emit("update:modelValue", value);
}

// 外部からmodelValueが変更された場合をwatchで監視


watch(
  () => props.modelValue,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      // 外部からmodelValueが変更された際の処理
      emit("modelValueChanged", newValue); // 変更イベントをemit
      console.log(`modelValue changed from ${oldValue} to ${newValue}`);
      isChanged.value=true;
    }
  }
);
</script>
